import { eTargetState, TargetBase } from "./Target";
import { ePhysicsObjects } from "../../Stadium/Stadium";
import { TargetManager } from "../TargetManager";
import { TargetType } from "../TargetType";
import { eManulSortLayerDrawOrder } from "../../../Game";
import { TIMER } from "../../Gameplay";



export class FireRingTarget extends TargetBase {
    private static readonly RADIUS = 0.5;
    private static readonly ANIM_SPEED = 1000 / 10;
    private static readonly ANIM_FRAME_CNT = 16;

    private _frameId: number;
    private _nextFrameTime: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(mng: TargetManager, type: TargetType) {
        super(mng, type);

        // Detekce kolize
        this._entity.addComponent(pc.eCompomentType.collision, {
            type: pc.eCollisionVolumeType.cylinder,
            radius: FireRingTarget.RADIUS * 0.82,
            height: 0.2,
            axis: 1
        });
        this._entity.collision.on("triggerenter", this.handleTriggerEnter, this);

        // Velikost terce
        this._width = this._height = FireRingTarget.RADIUS * 2;

        // Nasobeni skore
        this._scoreMultiplier = 1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (this._state != eTargetState.hidden) {
            super.update();

            // Animace
            if (TIMER.time > this._nextFrameTime) {
                this._nextFrameTime = TIMER.time + FireRingTarget.ANIM_SPEED;

                if (++this._frameId == FireRingTarget.ANIM_FRAME_CNT)
                    this._frameId = 0;

                this.setAtlasFrame("targets/1_" + (this._frameId < 10 ? "0" : "") + this._frameId);
            }

            this._container.rotate(0, 0, this._state != eTargetState.hit ? 0.5 : 3);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected init(): void {
        // Index snimku
        this._frameId = 0;
        this._nextFrameTime = TIMER.time + FireRingTarget.ANIM_SPEED;

        // Poradi vykreslovani terce
        this._entity.model.meshInstances[0].drawOrder = eManulSortLayerDrawOrder.target + this._id;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected updateScale(): void {
        this._entity.collision.radius = FireRingTarget.RADIUS * 0.82 * this._scale;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected updateOpacity(): void {
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleTriggerEnter(other: pc.Entity): void {
        if (this._opacity < 0.25 || other.name != ePhysicsObjects.ball || this._state != eTargetState.idle)
            return;

        let targetPos = this._container.getPosition();
        let ballPos = other.getPosition();
        let hitEntry = this.calculateHit(new pc.Vec2(targetPos.x, targetPos.y), new pc.Vec2(ballPos.x, ballPos.y));

        if (!hitEntry)
            return;

        // Animace zmizeni
        this.startHitAnim();

        // Predat udalost "triggerenter" mici
        other.collision.fire("triggerenter", this._entity);
    }
}